
<form [formGroup]="addressForm">
 <div *ngIf="isJsonShow">
  {{addressForm?.value | json}}
  </div>
  <div class="step-container">
    <ng-template #labelOne>{{ getTranslation('profile.sevaProfile') }}</ng-template>
    <div class="step-title">
      {{ isEditable ? getTranslation('address.title') : getTranslation('address.blockedForEdit') }}
      <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
    </div>
    <nb-accordion multi>

      <!-- Current Address -->
      <nb-accordion-item [expanded]="true">
        <nb-accordion-item-header>
          {{ getTranslation('address.title') }}
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <div formGroupName="currentAddress">
            <div *ngIf="isJsonShow">
              {{ currentAddressForm.value | json }}
            </div>

            <div class="row gx-2">
              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentStreetAddress" class="form-label">{{ getTranslation('address.streetAddress') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="currentStreetAddress" formControlName="StreetAddress" [placeholder]="getTranslation('address.enterStreetAddress')" [maxlength]="CONSTANTS.MaxLength.inputField" [class.submitted]="submitted">
                <div *ngIf="submitted && currentAddressForm.controls['StreetAddress'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['StreetAddress'].errors?.['required']">{{ getTranslation('validation.streetAddressRequired') }}</span>
                  <span *ngIf="currentAddressForm.controls['StreetAddress'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentTownCity" class="form-label">{{ getTranslation('address.townCity') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="currentTownCity" formControlName="TownCity" [placeholder]="getTranslation('address.enterTownCity')" [maxlength]="CONSTANTS.MaxLength.inputField" [class.submitted]="submitted">
                <div *ngIf="submitted && currentAddressForm.controls['TownCity'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['TownCity'].errors?.['required']">{{ getTranslation('validation.townCityRequired') }}</span>
                  <span *ngIf="currentAddressForm.controls['TownCity'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentDistrict" class="form-label">{{ getTranslation('address.district') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="currentDistrict" formControlName="District" [placeholder]="getTranslation('address.enterDistrict')" (keypress)="genericValidations.onlyLettersValidator($event)" [maxlength]="CONSTANTS.MaxLength.inputField" [class.submitted]="submitted">
                <div *ngIf="submitted && currentAddressForm.controls['District'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['District'].errors?.['required']">{{ getTranslation('validation.districtRequired') }}</span>
                  <span *ngIf="currentAddressForm.controls['District'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>
            </div>

            <div class="row gx-2">
              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentState" class="form-label">{{ getTranslation('address.state') }} <span class="text-danger">*</span></label>
                <select class="form-control" id="currentState" formControlName="State" required [class.submitted]="submitted">
                  <option value="" disabled selected>{{ getTranslation('address.selectState') }}</option>
                  <option *ngFor="let state of indianStateOptions" [value]="state.id">{{ state.name }}</option>
                </select>
                <div *ngIf="submitted && currentAddressForm.controls['State'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['State'].errors?.['required']">{{ getTranslation('validation.stateRequired') }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentPinCode" class="form-label">{{ getTranslation('address.pinCode') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="currentPinCode" formControlName="PinCode" [placeholder]="getTranslation('address.enterPinCode')" maxlength="6" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
                <div *ngIf="submitted && currentAddressForm.controls['PinCode'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['PinCode'].errors?.['required']">{{ getTranslation('validation.pinCodeRequired') }}</span>
                  <span *ngIf="currentAddressForm.controls['PinCode'].errors?.['pattern']">{{ getTranslation('validation.pinCodeInvalid') || 'Pin code must be 6 digits' }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentMobile" class="form-label">{{ getTranslation('address.mobilePersonal') }}:</label>
                <div class="d-flex">
                  <div class="country-code-container">
                    <ng-select
                      formControlName="CountryCode"
                      [items]="countryCodeOptions"
                      bindLabel="code"
                      bindValue="code"
                      [searchable]="true"
                      [clearable]="false"
                      [placeholder]="getTranslation('address.selectCountry')"
                      [class.submitted]="submitted"
                >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.code }} ({{ item.country }})
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.code }} ({{ item.country }})
                      </ng-template>
                    </ng-select>
                  </div>
                  <input type="text" class="form-control mobile-number-input" id="currentMobile" formControlName="Mobile" [placeholder]="getTranslation('address.enterHomePhone')" maxlength="15" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
                </div>
                <div *ngIf="submitted && currentAddressForm.controls['CountryCode'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['CountryCode'].errors?.['required']">{{ getTranslation('validation.countryCodeRequired') }}</span>
                </div>
                <div *ngIf="submitted && currentAddressForm.controls['Mobile'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['Mobile'].errors?.['required']">{{ getTranslation('validation.mobileRequired') }}</span>
                  <span *ngIf="currentAddressForm.controls['Mobile'].errors?.['pattern']">{{ getTranslation('validation.mobileInvalid') }}</span>
                  <span *ngIf="currentAddressForm.controls['Mobile'].errors?.['maxlength']">{{ getTranslation('validation.mobileMaxLength') }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentWorkPhone" class="form-label">{{ getTranslation('address.mobileAlternate') }}:</label>
                <input type="text" class="form-control" id="currentWorkPhone" formControlName="WorkPhone" [placeholder]="getTranslation('address.enterWorkPhone')" maxlength="10" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
                <div *ngIf="submitted && currentAddressForm.controls['WorkPhone'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['WorkPhone'].errors?.['pattern']">{{ getTranslation('validation.workPhoneInvalid') || 'Work phone must be 10 digits' }}</span>
                  <span *ngIf="currentAddressForm.controls['WorkPhone'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="currentEmail" class="form-label">{{ getTranslation('address.email') }}:</label>
                <input type="Email" class="form-control" id="currentEmail" formControlName="Email" [placeholder]="getTranslation('address.enterEmail')" maxlength="50" [class.submitted]="submitted">
                <div *ngIf="submitted && currentAddressForm.controls['Email'].invalid" class="text-danger">
                  <span *ngIf="currentAddressForm.controls['Email'].errors?.['email']">{{ getTranslation('validation.emailInvalid') || 'Invalid email format' }}</span>
                  <span *ngIf="currentAddressForm.controls['Email'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>
            </div>
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>

      <!-- Permanent Address -->
      <nb-accordion-item [expanded]="true">
        <nb-accordion-item-header>
          {{ getTranslation('permanentAddress.title') }}
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <!-- Checkbox to indicate same as residential address -->
          <div class="form-group mb-3" *ngIf="!isPreviewMode && isEditable">
            <div class="same-address-container compact">
              <div class="same-address-content">
                <div class="checkbox-wrapper">
                  <input 
                    type="checkbox" 
                    id="SameAsCurrrentAddress" 
                    [formControl]="sameAsCurrentAddressControl" 
                    (change)="onSameAsResidentialAddressChange($event)" 
                    class="custom-checkbox compact"
                  />
                  <label for="SameAsCurrrentAddress" class="checkbox-label compact">
                    <span class="checkbox-icon">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/>
                      </svg>
                    </span>
                    <span class="label-text compact">
                      <span class="primary-text">{{ getTranslation('permanentAddress.sameAsCurrent') }}</span>
                      <span class="secondary-text">{{ getTranslation('permanentAddress.isSameAsCurrent') }}</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div formGroupName="permanentAddress">
            <div *ngIf="isJsonShow">
              {{ permanentAddressForm.value | json }}
            </div>

            <div class="row gx-2">
              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentStreetAddress" class="form-label">{{ getTranslation('address.streetAddress') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="permanentStreetAddress" formControlName="StreetAddress" [placeholder]="getTranslation('address.enterStreetAddress')" [maxlength]="CONSTANTS.MaxLength.inputField" [class.submitted]="submitted">
                <div *ngIf="submitted && permanentAddressForm.controls['StreetAddress'].invalid" class="text-danger">
                  <span *ngIf="permanentAddressForm.controls['StreetAddress'].errors?.['required']">{{ getTranslation('validation.streetAddressRequired') }}</span>
                  <span *ngIf="permanentAddressForm.controls['StreetAddress'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentTownCity" class="form-label">{{ getTranslation('address.townCity') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="permanentTownCity" formControlName="TownCity" [placeholder]="getTranslation('address.enterTownCity')" maxlength="50" [class.submitted]="submitted">
                <div *ngIf="submitted && permanentAddressForm.controls['TownCity'].invalid" class="text-danger">
                  <span *ngIf="permanentAddressForm.controls['TownCity'].errors?.['required']">{{ getTranslation('validation.townCityRequired') }}</span>
                  <span *ngIf="permanentAddressForm.controls['TownCity'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentDistrict" class="form-label">{{ getTranslation('address.district') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="permanentDistrict" formControlName="District" [placeholder]="getTranslation('address.enterDistrict')" (keypress)="genericValidations.onlyLettersValidator($event)" maxlength="50" [class.submitted]="submitted">
                <div *ngIf="submitted && permanentAddressForm.controls['District'].invalid" class="text-danger">
                  <span *ngIf="permanentAddressForm.controls['District'].errors?.['required']">{{ getTranslation('validation.districtRequired') }}</span>
                  <span *ngIf="permanentAddressForm.controls['District'].errors?.['maxlength']">{{ getTranslation('validation.maxLengthExceeded') || 'Maximum length exceeded' }}</span>
                </div>
              </div>
            </div>

            <div class="row gx-2">
              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentState" class="form-label">{{ getTranslation('address.state') }} <span class="text-danger">*</span></label>
                <select class="form-control" id="permanentState" formControlName="State" required [class.submitted]="submitted">
                  <option value="" disabled selected>{{ getTranslation('address.selectState') }}</option>
                  <option *ngFor="let state of indianStateOptions" [value]="state.id">{{ state.name }}</option>
                </select>
                <div *ngIf="submitted && permanentAddressForm.controls['State'].invalid" class="text-danger">
                  <span *ngIf="permanentAddressForm.controls['State'].errors?.['required']">{{ getTranslation('validation.stateRequired') }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentPinCode" class="form-label">{{ getTranslation('address.pinCode') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="permanentPinCode" formControlName="PinCode" [placeholder]="getTranslation('address.enterPinCode')" maxlength="6" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
                <div *ngIf="submitted && permanentAddressForm.controls['PinCode'].invalid" class="text-danger">
                  <span *ngIf="permanentAddressForm.controls['PinCode'].errors?.['required']">{{ getTranslation('validation.pinCodeRequired') }}</span>
                  <span *ngIf="permanentAddressForm.controls['PinCode'].errors?.['pattern']">{{ getTranslation('validation.pinCodeInvalid') || 'Pin code must be 6 digits' }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentMobile" class="form-label">{{ getTranslation('address.mobilePersonal') }}:</label>
                <div class="d-flex">
                  <div class="country-code-container">
                    <ng-select
                      formControlName="CountryCode"
                      [items]="countryCodeOptions"
                      bindLabel="code"
                      bindValue="code"
                      [searchable]="true"
                      [clearable]="false"
                      [placeholder]="getTranslation('address.selectCountry')"
                      [class.submitted]="submitted"
                      >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.code }} ({{ item.country }})
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.code }} ({{ item.country }})
                      </ng-template>
                    </ng-select>
                  </div>
                  <input type="text" class="form-control mobile-number-input" id="permanentMobile" formControlName="Mobile" [placeholder]="getTranslation('address.enterHomePhone')" maxlength="15" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
                </div>
                <div *ngIf="submitted && permanentAddressForm.controls['CountryCode'].invalid" class="text-danger">
                  <span *ngIf="permanentAddressForm.controls['CountryCode'].errors?.['required']">{{ getTranslation('validation.countryCodeRequired') }}</span>
                </div>
                <div *ngIf="submitted && permanentAddressForm.controls['Mobile'].invalid" class="text-danger">
                  <span *ngIf="permanentAddressForm.controls['Mobile'].errors?.['required']">{{ getTranslation('validation.mobileRequired') }}</span>
                  <span *ngIf="permanentAddressForm.controls['Mobile'].errors?.['pattern']">{{ getTranslation('validation.mobileInvalid') }}</span>
                  <span *ngIf="permanentAddressForm.controls['Mobile'].errors?.['maxlength']">{{ getTranslation('validation.mobileMaxLength') }}</span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentWorkPhone" class="form-label">{{ getTranslation('address.mobileAlternate') }}:</label>
                <input type="text" class="form-control" id="permanentWorkPhone" formControlName="WorkPhone" [placeholder]="getTranslation('address.enterWorkPhone')" maxlength="10" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="permanentEmail" class="form-label">{{ getTranslation('address.email') }}:</label>
                <input type="Email" class="form-control" id="permanentEmail" formControlName="Email" [placeholder]="getTranslation('address.enterEmail')" maxlength="50" [class.submitted]="submitted">
              </div>
            </div>
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>

      <!-- Emergency Contact -->
      <nb-accordion-item [expanded]="true">
        <nb-accordion-item-header>
          {{ getTranslation('emergencyContact.title') }}
        </nb-accordion-item-header>
        <nb-accordion-item-body>
          <div formGroupName="emergencyContact">
            <div *ngIf="isJsonShow">
              {{ emergencyContactForm.value | json }}
            </div>

            <div class="row gx-2">
              <div class="form-group col-12 col-md-4 mb-3">
                <label for="emergencyContactName" class="form-label">{{ getTranslation('emergencyContact.contactName') }} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" id="emergencyContactName" formControlName="EMERGENCYContactName" [placeholder]="getTranslation('emergencyContact.enterContactName')" maxlength="50" [class.submitted]="submitted">
                <div *ngIf="submitted && emergencyContactForm.controls['EMERGENCYContactName'].invalid" class="text-danger">
                  {{ getTranslation('validation.contactNameRequired') }}
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="emergencyRelationship" class="form-label">{{ getTranslation('emergencyContact.relationship') }} <span class="text-danger">*</span></label>
                <select class="form-control" id="emergencyRelationship" formControlName="EMERGENCYContacRelationship" [class.submitted]="submitted">
                  <option value="" disabled selected>{{ getTranslation('emergencyContact.selectRelationship') }}</option>
                  <option *ngFor="let option of relationshipOptions" [value]="option.id">{{ option.name }}</option>
                </select>
                <div *ngIf="submitted && emergencyContactForm.controls['EMERGENCYContacRelationship'].invalid" class="text-danger">
                  {{ getTranslation('validation.relationshipRequired') }}
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="emergencyMobile" class="form-label">{{ getTranslation('address.mobilePersonal') }}: <span class="text-danger">*</span></label>
                <div class="d-flex">
                  <div class="country-code-container">
                    <ng-select
                      formControlName="CountryCode"
                      [items]="countryCodeOptions"
                      bindLabel="code"
                      bindValue="code"
                      [searchable]="true"
                      [clearable]="false"
                      [placeholder]="getTranslation('address.selectCountry')"
                      [class.submitted]="submitted"
                      >
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.code }} ({{ item.country }})
                      </ng-template>
                      <ng-template ng-label-tmp let-item="item">
                        {{ item.code }} ({{ item.country }})
                      </ng-template>
                    </ng-select>
                  </div>
                  <input type="text" class="form-control mobile-number-input" id="emergencyMobile" formControlName="Mobile" [placeholder]="getTranslation('emergencyContact.enterEmergencyMobile')" maxlength="15" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
                </div>
                <div *ngIf="submitted && emergencyContactForm.controls['CountryCode'].invalid" class="text-danger">
                  <span *ngIf="emergencyContactForm.controls['CountryCode'].errors?.['required']">{{ getTranslation('validation.countryCodeRequired') }}</span>
                </div>
                <div *ngIf="submitted && emergencyContactForm.controls['Mobile'].invalid" class="text-danger">
                  <span *ngIf="emergencyContactForm.controls['Mobile'].errors?.['required']">{{ getTranslation('validation.mobileRequired') }}</span>
                  <span *ngIf="emergencyContactForm.controls['Mobile'].errors?.['pattern']">{{ getTranslation('validation.mobileInvalid') }}</span>
                  <span *ngIf="emergencyContactForm.controls['Mobile'].errors?.['maxlength']">{{ getTranslation('validation.mobileMaxLength') }}</span>
                  <span *ngIf="emergencyContactForm.controls['Mobile'].errors?.['sameAsCurrentMobile']">
                    {{ getTranslation('validation.mobileMustDiffer') || 'Emergency contact number must differ from current address number.' }}
                  </span>
                </div>
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="emergencyWorkPhone" class="form-label">{{ getTranslation('address.mobileAlternate') }}:</label>
                <input type="text" class="form-control" id="emergencyWorkPhone" formControlName="WorkPhone" [placeholder]="getTranslation('emergencyContact.enterWorkPhone')" maxlength="10" (keypress)="genericValidations.onlyNumberWithoutPointValidator($event)" [class.submitted]="submitted">
              </div>

              <div class="form-group col-12 col-md-4 mb-3">
                <label for="emergencyEmail" class="form-label">{{ getTranslation('address.email') }}:</label>
                <input type="email" class="form-control" id="emergencyEmail" formControlName="Email" [placeholder]="getTranslation('emergencyContact.enterEmergencyEmail')" maxlength="50" [class.submitted]="submitted">
              </div>
            </div>
          </div>
        </nb-accordion-item-body>
      </nb-accordion-item>

    </nb-accordion>
  </div>



  <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="addressForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="goToNext(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="goToNext(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->
</form>